import BreadcrumbsBlock from '@/blocks/BreadcrumbsBlock';
import FancyHeading from '@/components/FancyHeading';
import Prose from '@/components/Prose';
import { MEDIA_URL, REVALIDATE_TIME_IN_SEC } from '@/constants/env';
import { fadeIn, fadeInUp } from '@/constants/motions';
import { pages } from '@/content';
import FullWidthLayout from '@/layouts/FullWidthLayout';
import Image from '@/ui/Image';
import { motion } from 'framer-motion';
import graphql from '@/lib/graphql';
import mainLayout from '@/graphql/queries/mainLayout';
import Markdown from 'react-markdown';
import page from '@/graphql/queries/page';

export default function ManagementTeamPage({ mainLayout, page }) {
  const attributes = page?.attributes || {};
  const contentSection = attributes.contentSection || [];
  const metaData = attributes.metaData || {};
  return (
    <FullWidthLayout mainLayout={mainLayout} metaData={metaData}>
      <BreadcrumbsBlock items={[pages.home, pages.about, pages.managementTeam]} />
      <motion.section
        className="my-16 px-4"
        initial="hidden"
        transition={{
          ...fadeIn.transition,
          when: 'beforeChildren',
          staggerChildren: 0.4,
        }}
        variants={fadeIn}
        viewport={fadeIn.viewport}
        whileInView="visible"
      >
        <div className="container-screen">
          <FancyHeading variants={fadeInUp}>{attributes.shortName || ''}</FancyHeading>
          <div className="mt-16 grid gap-8">
            {(contentSection?.[0]?.cards || []).map(({ image, title, subtitle, text }, i) => (
              <motion.div
                key={i}
                className="flex flex-col items-center gap-x-8 gap-y-4 md:flex-row"
                variants={fadeInUp}
              >
                <div className="flex-shrink-0">
                  <Image
                    alt={title}
                    className="h-48 w-48 overflow-hidden rounded-full object-cover shadow-lg"
                    src={MEDIA_URL.concat(image?.data?.attributes?.url || '')}
                  />
                </div>
                <div className="text-center md:text-justify">
                  <div className="flex flex-col items-center gap-x-4 md:flex-row md:items-start">
                    <h2 className="text-lg font-semibold">{title}</h2>
                    <h3 className="text-lg font-light">{subtitle}</h3>
                  </div>
                  <Prose className="mt-4 max-w-full md:mt-2">
                    <Markdown>{text}</Markdown>
                  </Prose>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </motion.section>
    </FullWidthLayout>
  );
}

export async function getStaticProps() {
  const { data: mainLayoutData } = await graphql(mainLayout);

  const { data: pageData } = await graphql(page, { slug: 'management-team' });

  return {
    props: {
      mainLayout: mainLayoutData.mainLayout.data,
      page: pageData.pages.data[0],
    },
    revalidate: parseInt(REVALIDATE_TIME_IN_SEC), // In seconds
  };
}
